/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _config = require('../config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Notice = function () {
    function Notice(actHashId) {
        (0, _classCallCheck3["default"])(this, Notice);

        this.actHashId = actHashId;

        this._Sub();
        this._msgbusDestroy();
    }

    (0, _createClass3["default"])(Notice, [{
        key: 'Get',
        value: function Get(cb) {
            Fetcher.Get(_config.API_DOMAIN_V2 + '/v2/micro-act/view/announcement?act_id=' + this.actHashId, function (res) {
                var cbData = JSON.parse(res);
                typeof cb === 'function' && cb(cbData);
            });
        }
    }, {
        key: '_Sub',
        value: function _Sub() {
            this.unsubNotice = nats.on('mudu.activities.' + this.actHashId, function (message) {
                var msg = JSON.parse(message);
                if (msg.type && msg.type === 'activities.Announcement') {
                    _scope.MsgBus.Pub('Notice.Change', msg.data);
                }
            });
        }
    }, {
        key: '_msgbusDestroy',
        value: function _msgbusDestroy() {
            var _this = this;

            this.destroyKey = _scope.MsgBus.On('Destroy', function () {
                _scope.MsgBus.UnSub('Destroy', _this.destroyKey);
                _this.unsubNotice();
            });
        }
    }]);
    return Notice;
}(); /**
      * 公告组件
      */


module.exports = Notice;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/core/Notice.js
 ** module id = 189
 ** module chunks = 1
 **/